import { treaty } from "@elysiajs/eden";
import type { App } from "@app/api";

// Base URL for the API
// In development: proxied via Vite (/api -> localhost:3000)
// In production: proxied via nginx (/api -> api:3000)
// Note: Eden treaty needs an absolute URL (a bare "/api" becomes "https://api/"),
// so the dev fallback is resolved against the current origin.
const API_URL =
  import.meta.env.VITE_API_URL ??
  (typeof window !== "undefined" ? `${window.location.origin}/api` : "/api");

// Create Eden Treaty client with full type inference
export const api = treaty<App>(API_URL);

// Export types for convenience
export type { App };
